@if (show$ | async) {
    <mat-progress-bar
        [mode]="(mode$ | async)!"
        [value]="(progress$ | async) ?? 0"
    ></mat-progress-bar>
}
